import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Key = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M32.102 9.389a2.919 2.919 0 1 0 0 5.838 2.919 2.919 0 0 0 0-5.838Zm-5.013 2.92a5.014 5.014 0 1 1 5.013 5.014 5.014 5.014 0 0 1-5.013-5.015Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M20.707 4.416C26.032-.91 34.666-.909 40.003 4.4l.002.002c5.324 5.326 5.324 13.965 0 19.29-3.459 3.46-8.288 4.66-12.708 3.648l-4.83 4.83a1.047 1.047 0 0 1-1.031.266l-4.46-.256.267 4.665a1.048 1.048 0 0 1-1.106 1.106l-4.663-.268.256 4.462a1.047 1.047 0 0 1-.266 1.032l-.39.391c-.182.182-.424.29-.68.305l-9.285.545a1.047 1.047 0 0 1-1.107-1.107l.544-9.288c.015-.257.124-.498.305-.68l16.21-16.215c-1.012-4.423.201-9.266 3.646-12.712Zm.636 25.916 4.893-4.895c.267-.267.657-.37 1.02-.268 3.885 1.077 8.21.101 11.268-2.958 4.506-4.507 4.506-11.819.001-16.326-4.52-4.496-11.832-4.494-16.337.012-3.045 3.047-4.033 7.387-2.957 11.271.101.364-.002.754-.268 1.021L2.613 34.543l-.451 7.715 7.451-.438-.298-5.19a1.048 1.048 0 0 1 1.106-1.106l4.664.268-.268-4.665a1.048 1.048 0 0 1 1.105-1.106l5.421.311Z"
  })));
});
Key.displayName = 'Key';
Key.defaultProps = {
  'aria-label': 'Key'
};
export default Key;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Key.js
// module id = 3818
// module chunks = 11